document.addEventListener('click', (event) => {
  const openTrigger = event.target.closest('[data-glass-hero-video-open]');
  if (openTrigger) {
    const modal = openTrigger.closest('.glass-hero, [id^="glass-hero-"]')?.querySelector('[data-glass-hero-video-modal]')
      ?? document.querySelector('[data-glass-hero-video-modal]');
    if (!modal) return;
    openVideoModal(modal);
    return;
  }

  const closeTrigger = event.target.closest('[data-glass-hero-video-close]');
  if (closeTrigger) {
    const modal = closeTrigger.closest('[data-glass-hero-video-modal]');
    if (modal) closeVideoModal(modal);
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const openModal = document.querySelector('[data-glass-hero-video-modal]:not([hidden])');
  if (openModal) closeVideoModal(openModal);
});

function openVideoModal(modal) {
  modal.hidden = false;
  document.body.style.overflow = 'hidden';
  const video = modal.querySelector('video');
  if (video) {
    video.currentTime = 0;
    video.play().catch(() => {});
  }
}

function closeVideoModal(modal) {
  modal.hidden = true;
  document.body.style.overflow = '';
  const video = modal.querySelector('video');
  if (video) video.pause();
}
